import React from "react";
import {
  Box,
  Text,
  Link,
  Stack,
  Heading,
  Flex,
  VStack,
  List,
  ListItem,
} from "@chakra-ui/react";

import { GetNotice } from "../../pages/api/base";
import { checkIEAccess } from "../../provider/common";

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notice: [],
    };
  }
  componentDidMount() {
    this.notice();
    checkIEAccess();
  }

  notice = async () => {
    const notice = await GetNotice();
    this.setState({ notice: notice });
  };

  render() {
    const { notice } = this.state;
    return (
      <Box className="maxist_body">
        <Box w="100%" color="#555" borderTop="1px" borderColor="#ededed">
          <Box
            bg=""
            borderTop="1px"
            borderColor="#ededed"
            w="100%"
            p={0}
            mb={5}
            color="#a3a5ad"
            fontSize={12}
            letterSpacing={-0.5}
          >
            <Stack
              direction="row"
              spacing={5}
              pt="5"
              pb="1"
              margin="0 auto"
              textAlign="center"
              w="1000px"
              justifyContent="center"
              className="maxist_body_children"
            >
              <Text>Copyright © 2025 PARTSGO. All rights reserved. </Text>
            </Stack>
            <Stack
              direction="row"
              spacing={5}
              align="center"
              mt="5"
              mb="5"
              w="1000px"
              margin="0 auto"
              justifyContent="center"
              className="maxist_body_children"
            >
              <Link href="/en/board/home?status=Terms">
                <Text colorScheme="gray" variant="ghost" p="2">
                  Terms
                </Text>
              </Link>
              <Link href="/en/board/home?status=Privacy">
                <Text colorScheme="gray" variant="ghost" p="2">
                  Privacy
                </Text>
              </Link>
            </Stack>

            <Text
              w="1000px"
              margin="0 auto"
              paddingTop="1"
              textAlign="center"
              className="maxist_body_children"
            >
              5F, DI Tower Buliding, 15, Teheran-ro 82-gil, Gangnam-gu, Seoul,
              Republic of Korea
            </Text>
          </Box>
        </Box>
      </Box>
    );
  }
}
